import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Globe2, MapPin } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const Region = ({ icon: Icon, pkg, places, delay, testid }) => (
  <Reveal delay={delay}>
    <div className="rounded-[28px] border border-white/10 bg-[#13114f]/80 backdrop-blur p-7 md:p-9" data-testid={testid}>
      <div className="flex items-center gap-3 text-[#8a8dff]"><Icon size={20} /><span className="text-xs uppercase tracking-[0.25em]">{pkg}</span></div>
      <div className="mt-6 flex flex-wrap gap-2">
        {places.map((pl) => (
          <span key={pl} className="font-display text-lg md:text-2xl font-semibold rounded-full border border-white/15 px-4 py-2">{pl}</span>
        ))}
      </div>
    </div>
  </Reveal>
);

export default function Coverage() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="kapsam" ref={ref} className="relative bg-[#08072a] py-24 md:py-36 overflow-hidden" data-testid="coverage-section">
      <div className="mx-auto max-w-7xl px-5 md:px-10 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div>
          <SectionHead kicker="03 · Kapsam" title={<>Neredeysen<br />orada.</>} testid="coverage-title"
            sub="Türkiye Elmas Paket üç ülkede, Avrupa Elmas Paket tüm dünyada çalışır." />
          <div className="space-y-4">
            <Region icon={MapPin} pkg="Türkiye Elmas Paket" places={["Türkiye", "Azerbaycan", "K.K.T.C"]} delay={0.05} testid="coverage-turkiye" />
            <Region icon={Globe2} pkg="Avrupa Elmas Paket" places={["Tüm Dünya"]} delay={0.15} testid="coverage-avrupa" />
          </div>
        </div>
        <Reveal>
          <div className="relative aspect-[4/5] overflow-hidden rounded-t-[999px] rounded-b-[32px] border border-white/10">
            <motion.img style={{ y, scale: 1.25 }} src="/img/cinema.jpg" alt="Sinema keyfi" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#08072a] via-transparent to-[#5b5fd6]/20" />
            <div className="absolute bottom-8 left-8 right-8">
              <p className="font-display text-5xl md:text-7xl font-extrabold">500K+</p>
              <p className="text-[#c9c6f0] mt-1">içerik, her iki pakette de</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
